import { useQuery } from '@tanstack/react-query';

import { kinds, type EnvKey } from '@/app/site/scope';
import { templatesList } from '@/shared/api/generated/content/content';
import type { TemplateBody } from '@/shared/api/generated/model';

/**
 * Шаблоны раздела: «Модели» показывают шаблоны данных (каталог, блог),
 * «Формы» — шаблоны форм. Список общий, раздел — по назначению шаблона.
 */
export function useTemplates(siteID: string, env: EnvKey, purpose: TemplateBody['purpose']) {
  const list = useQuery({
    queryKey: ['templates', siteID, env],
    queryFn: async () => {
      const response = await templatesList(siteID, kinds[env]);

      if (response.status !== 200) {
        throw new Error('Неожиданный ответ на список шаблонов');
      }

      return response.data.items ?? [];
    },
  });

  return { ...list, data: list.data?.filter((template) => template.purpose === purpose) };
}
